import { atom } from 'recoil';
import { IHiringContract } from '../model/HiringContract/IHiringContract';
import { IVendor } from '../model/IVendor';

export const hiringContractsState = atom<IHiringContract[]>({
  key: 'hiringContractsState',
  default: undefined,
});

export const activeContractsState = atom<IHiringContract[]>({
  key: 'activeContractsState',
  default: undefined,
});

export const vendorDetailsState = atom<IVendor>({
  key: 'vendorDetailsState',
  default: undefined,
});
